<button (click)="login()" class="d-flex justify-content-between my-2 fs12 fw500 p-3 cF text-uppercase mx-auto"
    style="background-color: #007fb1;">
    <span>Continue with Linkedin</span>
    <img src="assets/images/svg/linkdin.svg" alt="Linkedin" />
</button>